<template>
  <section class="donation-step-section">
    <h2>การเจาะเลือด<strong>คัดกรอง</strong> ก่อนบริจาคเลือด</h2>
    <container>
      <div class="col donation-step-container">
        <div class="donation-step">
          <img src="@/assets/donation-info/donation-step-1.png" alt="blood donation step">
          <span class="content">ตรวจค่าตับ</span>
        </div>
        <div class="donation-step">
          <img src="@/assets/donation-info/donation-step-2.png" alt="blood donation step">
          <span class="content">ตรวจค่าไต</span>
        </div>
        <div class="donation-step">
          <img src="@/assets/donation-info/donation-step-3.png" alt="blood donation step">
          <span class="content">ตรวจพยาธิเม็ดเลือด</span>
        </div>
        <div class="donation-step">
          <img src="@/assets/donation-info/donation-step-4.png" alt="blood donation step">
          <span class="content">ตรวจพยาธิหนอนหัวใจ</span>
        </div>
      </div>
    </container>
    <p>
      * ขั้นตอนนี้ จำเป็นต้องรอผลเลือดเป็นระยะเวลา 15 นาที ถึง หลายชั่วโมง แล้วแต่โรงพยาบาล
    </p>
    <p>
      ** เมื่อบริจาคเลือดเป็นประจำ จะทำให้น้องหมาและน้องแมว สามารถเช็คสุขภาพไปในตัว ทุกๆ 3-4 เดือน
    </p>
  </section>
</template>

<script>
import Container from '@/components/Container.vue'

export default {
  name: 'DonationStepSection',
  components: {
    Container
  }
}
</script>

<style scoped lang="scss">
.donation-step-section {
  padding: 2rem 0;
  h2 {
    text-align: center;
    font-size: $h3-font-size;
    font-weight: $font-weight-light;
    strong {
      font-weight: $font-weight-normal;
    }
  }
  p {
    margin: 1rem;
    color: $gray-500;
    font-weight: $font-weight-light;
    font-family: $font-family-thai;
    text-align: center;
  }
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .donation-step-section {
    h2 {
      font-size: $h1-font-size;
    }
  }
}
</style>
